let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("7u21b")]).then(() => parcelRequire('gQ8xi'));